import React from 'react';

const DashboardCalendar = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33333 4.66667V2V4.66667ZM10.6667 4.66667V2V4.66667ZM14 10H2H14ZM4 14H12C13.1046 14 14 13.1046 14 12V5.33333C14 4.22877 13.1046 3.33333 12 3.33333H4C2.89543 3.33333 2 4.22877 2 5.33333V12C2 13.1046 2.89543 14 4 14Z"
        stroke="#787F88"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardCalendar;
